import { render, staticRenderFns } from "./OfficialHolidaysPlanEdit.vue?vue&type=template&id=d7474e12&scoped=true&"
import script from "./OfficialHolidaysPlanEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7474e12",
  null
  
)

export default component.exports